import { BaseModel } from '../../../models/base-model'

export class Test extends BaseModel {
  public name: string
  public algorithm: string
  public config: {} = {}
  public frontendConfig: {} = {}
  public experienceType: string
  public maxTakes: number
  public accessible: boolean

  public getConfig(key: string) {
    return this.config[key] || this.frontendConfig[key]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test/test.ts